import { invokeApi } from "../Utils/InvokeApi";
import { invokeApi2 } from "../Utils/InvokeApi2";

export const fetchAdminList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/user/admin/get-list?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchAssignTagUsersList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/show-assign-stream-tag?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};

export const fetchAdminDetail = async (id) => {
  const reqObj = {
    path: `/user/admin/get-one/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchGifterHistoryList = async (id, start, end, type) => {
  const reqObj = {
    path: `/gifter-ranking-history/${id}?startDate=${start}&endDate=${end}&type=${type}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const fetchallpermisions = async () => {
  const reqObj = {
    path: `/permission`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchPermisionList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/permission?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchCategoriesList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/get-product-categories?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const fetchUserList = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/user/?filter=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchUserProfileList = async (page, rowsPerPage, status) => {
  const reqObj = {
    path: `/user/admin/profile-approval-list/${status}?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const searchUser = async (data) => {
  const reqObj = {
    path: `/user/get-by-codes`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const fetchUserDetail = async (id) => {
  const reqObj = {
    path: `/user/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchPk = async (page, rowsPerPage, search, date) => {
  const reqObj = {
    path: `/show-pks?limit=${rowsPerPage}&page=${page}&search=${search}&date=${date}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const fetchPkDetail = async (id) => {
  const reqObj = {
    path: `/show-pk/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const fetchTagList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/get-tags?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const fetchGifts = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/gift?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchGiftById = async (id) => {
  const reqObj = {
    path: `/gift/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchProducts = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/show-products?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const fetchGiftDetail = async (id) => {
  const reqObj = {
    path: `/show-products-by-category/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const fetchAgencyList = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/agency?limit=${rowsPerPage}&page=${page}&search=${search}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchAgencyDetail = async (id) => {
  const reqObj = {
    path: `/agency/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const fetchBussinessDevelopersList = async (rowsPerPage, page) => {
  const reqObj = {
    path: `/business-developer?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetRcoinsHistory = async (
  search,
  rowsPerPage,
  page,
  start,
  end
) => {
  const reqObj = {
    path: `/wallet-transaction/receive-rcoin-history?search=${search}&limit=${rowsPerPage}&page=${page}&startDay=${start}&endDay=${end}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetDashboardStats = async () => {
  const reqObj = {
    path: `/user/statistics`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetSenderLevelList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/show-sender-levels?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetHostsLevelList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/show-host-level-info?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetDiamondsPackagesList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/package?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetDiamondsPackageByIdList = async (id) => {
  const reqObj = {
    path: `/package/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetAllMoments = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/all-moment-posts?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetApproveMoments = async (status, page, rowsPerPage, search) => {
  const reqObj = {
    path: `/all-moment-posts?status=${status}&search=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetReportMoments = async (search, page, rowsPerPage) => {
  const reqObj = {
    path: `/moment-report-list?search=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetVideoApproveMoments = async (
  status,
  page,
  rowsPerPage,
  search
) => {
  const reqObj = {
    path: `/get-video-list?status=${status}&search=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetFamilyList = async (rowsPerPage, page, status) => {
  const reqObj = {
    path: `/family?limit=${rowsPerPage}&page=${page}&status=${status}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetFamilyRuleList = async (search, rowsPerPage, page) => {
  const reqObj = {
    path: `/list-family-rules?search=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetFamilyReportList = async (search, rowsPerPage, page) => {
  const reqObj = {
    path: `/family-report-list?search=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetFamilyById = async (id) => {
  const reqObj = {
    path: `/family/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetFamilyRuleById = async (id) => {
  const reqObj = {
    path: `/get-family-rule/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetBubbleImages = async () => {
  const reqObj = {
    path: `/get-text-bubbles`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetSingleBubbleImages = async (id) => {
  const reqObj = {
    path: `/get-text-bubble/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetAllImages = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/image?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetSingleImage = async (id) => {
  const reqObj = {
    path: `/image/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetAllRIDList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/get-special-rids?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetSingleRID = async (id) => {
  const reqObj = {
    path: `/get-special-rid/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetProductDetail = async (id) => {
  const reqObj = {
    path: `/get-product/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetMerchandDetail = async (id) => {
  const reqObj = {
    path: `/merchant/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetCustomerDetail = async (id) => {
  const reqObj = {
    path: `/get-customer-support/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetProfiletag = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/get-profile-tags?search=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};

export const GetDiamondList = async (page, per_page, start, end, rid, type) => {
  const reqObj = {
    path: `/send-diamond-history-list?limit=${per_page}&page=${page}&startDate=${start}&endDate=${end}&search=${rid}&type=${type}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetSvip = async (page, per_page) => {
  const reqObj = {
    path: `/vip?limit=${per_page}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetProfileTagUsersList = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/user-profile-tag-list?search=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetSenderLevelUsersList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/show-user-sender-level-list?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetHostLevelUsersList = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/show-user-host-level-list?limit=${rowsPerPage}&page=${page}&search=${search}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetWithdrawList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/withdraw-payment-list?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetWithdrawalsReportList = async (search, page, rowsPerPage) => {
  const reqObj = {
    path: `/withdraw-transaction/report-list?search=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetWithdrawalsRequestList = async (
  search,
  page,
  rowsPerPage,
  status
) => {
  const reqObj = {
    path: `/withdraw-request-list?search=${search}&limit=${rowsPerPage}&page=${page}&status=${status}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetSingleWithdrawalsRequest = async (id, status) => {
  const reqObj = {
    path: `/withdraw-request/${id}?status=${status}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const getResellerByIdAPI = async (id) => {
  const reqObj = {
    path: `/get-reseller/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetHostList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/agency/join-agency-requests?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const GetDonationList = async (
  page,
  rowsPerPage,
  id,
  type,
  start,
  end,
  subType
) => {
  const reqObj = {
    path: `/donation-log-history/${id}?limit=${rowsPerPage}&page=${page}&type=${type}&startDate=${start}&endDate=${end}&subType=${subType}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetHostRankList = async (page, rowsPerPage, filter, country) => {
  const reqObj = {
    path: `/host-ranking?limit=${rowsPerPage}&page=${page}&filter=${filter}&country=${country}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetInviteRankList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/invitation-ranking?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetGiftRankList = async (page, rowsPerPage, filter, country) => {
  const reqObj = {
    path: `/gifter-ranking?limit=${rowsPerPage}&page=${page}&filter=${filter}&country=${country}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetWalletList = async (
  page,
  rowsPerPage,
  id,
  type,
  start,
  end,
  subType
) => {
  const reqObj = {
    path: `/wallet-transaction-history/${id}?limit=${rowsPerPage}&page=${page}&type=${type}&startDate=${start}&endDate=${end}&subType=${subType}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetReportList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/livestream-report-list?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetUserReportList = async (search, page, rowsPerPage) => {
  const reqObj = {
    path: `/user-report-list?search=${search}&limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetDeactivateUserList = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/deactive-user-list?limit=${rowsPerPage}&page=${page}&search=${search}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetBannedUserList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/banned-user-history?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const GetGiftHistoryList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/gift-history-list?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const fetchMerchand = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/merchant-list?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const DeactiveBannerList = async (page, rowsPerPage) => {
  const reqObj = {
    path: `/deactivate-banner-list?limit=${rowsPerPage}&page=${page}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const BannersListApi = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/show-banners-list?limit=${rowsPerPage}&page=${page}&search=${search}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const ActiveBannersListApi = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/active-banner-list?limit=${rowsPerPage}&page=${page}&search=${search}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const ResellerList = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/reseller-list?limit=${rowsPerPage}&page=${page}&search=${search}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const CustomerList = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/customer-support-list?limit=${rowsPerPage}&page=${page}&search=${search}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const CustomerCSR = async (page, rowsPerPage, search) => {
  const reqObj = {
    path: `/get-customer-conversations`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const CustomerDetail = async (id, page, rowsPerPage, search) => {
  const reqObj = {
    path: `/get-conversation-messages/${id}`,
    method: "GET",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
